import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CardMemberAvatar from '@atoms/CardMemberAvatar';
import { BodyMedium, PatternLightStyled, DivWithShadowAlternate, H4 } from '@styled';

import colors from '@general/colors';
import { getDisplayAddress } from '@general/helpers/address.helpers';
import useMemberFull from '@hooks/useMemberFull';
import useMemberTenure from '@hooks/useMemberTenure';
import { useScreenSmDown } from '@hooks/useResponsive';
import styled from 'styled-components';

const StyledMemberRecongition = styled.div`
    position: absolute;
    right: 2rem;
    top: 1rem;
`;

const StyledImage = styled.img`
    min-width: 60px;
    max-width: 60px;
`;

const MemberTenureRecognition = ({ isMobile }) => {
    return (
        <StyledImage
            alt="25 Year Member"
            isMobile={isMobile}
            src="/assets/images/member-tenure-recognition-25-profile.svg"
        />
    );
};

const MemberProfileCard = ({ graphID }) => {
    const [secondaryBusinessType, setSecondaryBusinessType] = useState();

    const { data } = useMemberFull(graphID);
    const tenure = useMemberTenure(data?.recordId);
    const displayMemberTenureBadge = tenure !== undefined && tenure !== null && tenure >= 25;
    const isScreenSmDown = useScreenSmDown();

    useEffect(() => {
        if (!data?.secondaryBusinessTypes?.length) {
            return;
        }

        const { name } = data.secondaryBusinessTypes[0];
        setSecondaryBusinessType(name.includes('-') ? name.split('-')[1] : name);
    }, [data]);

    if (!data) {
        return null;
    }

    return (
        <DivWithShadowAlternate style={{ width: '100%' }}>
            <PatternLightStyled style={{ height: '100%' }}>
                <StyledMemberRecongition isMobile={isScreenSmDown}>
                    {displayMemberTenureBadge && <MemberTenureRecognition />}
                </StyledMemberRecongition>
                <div className="align-items-center d-flex justify-content-center mb-2rem">
                    <CardMemberAvatar
                        photoURL={data.photoUrl}
                        firstName={data.firstName}
                        lastName={data.lastName}
                        fullName={`${data.firstName} ${data.lastName}`}
                        sizeMobile={100}
                        sizeDesktop={182}
                    />
                </div>
                <H4 className="mb-1rem text-center">
                    {`${data.firstName} ${data.lastName}`}
                    {data?.designations && <span>, {data.designations.join(', ')}</span>}
                </H4>
                <BodyMedium className="text-center">
                    <span style={{ color: colors.background, display: 'block' }}>{data.title}</span>
                    <span style={{ color: colors.background, display: 'block', marginBottom: '.3rem' }}>
                        {getDisplayAddress(data.address)}
                    </span>

                    {data.company && (
                        <Link
                            to={{
                                pathname: `/company/profile/${data.company?.recordId}`,
                                state: { inApp: true },
                            }}
                            className="profile-co-link"
                        >
                            <span className="font-bold text-primary">{data.company?.name}</span>
                        </Link>
                    )}

                    {data.company?.primaryBusinessType.name && (
                        <span>
                            <br />
                            {data.company.primaryBusinessType.name}
                        </span>
                    )}

                    {secondaryBusinessType && (
                        <span>
                            <br />
                            {secondaryBusinessType}
                        </span>
                    )}
                </BodyMedium>
            </PatternLightStyled>
        </DivWithShadowAlternate>
    );
};

MemberProfileCard.propTypes = {
    graphID: PropTypes.string,
};

MemberTenureRecognition.propTypes = {
    isMobile: PropTypes.bool,
};

export default MemberProfileCard;
